(() => {
  document.querySelectorAll('[data-pot-all-products]').forEach((section) => {
    const track = section.querySelector('[data-pot-products-track]');
    const group = track?.querySelector('[data-pot-products-group]');
    if (!group) return;

    const setDuration = () => {
      track.style.setProperty('--pot-track-duration', `${Math.max(140, group.scrollWidth / 72)}s`);
    };

    requestAnimationFrame(setDuration);
    section.querySelectorAll('img').forEach((image) => {
      image.addEventListener('load', setDuration, { once: true });
    });
    window.addEventListener('resize', setDuration, { passive: true });
  });
})();
